module.exports = __webpack_public_path__ + "img/qr3.a9019f11.png";